import { useNavigate, useParams } from "react-router-dom";

import { Button, Divider, Flex, notification } from "antd";
import { useBuscarMutation } from "@/Services/Financeiro/Titulo/TituloService";
import { useEffect } from "react";
import { PropriedadesDeNotificacao } from "@/Utils/Notificacoes";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";
import APagarLancamentoForm from "./APagar/lancamento/APagarLancamentoForm";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
import AReceberLancamentoForm from "./AReceber/lancamento/AReceberLancamentoForm";

interface ITituloVisualizarScreenProps {
    codigo?:number;
    onClose?:() => void;
}
export default function TituloVisualizarScreen({
    codigo : codigoParam,
    onClose
}:ITituloVisualizarScreenProps) {
    const navigate = useNavigate();

    const { codigo : codigoRota } = useParams();
    const codigo = isNaN(Number.parseInt(codigoRota ?? "")) ? codigoParam : Number.parseInt(codigoRota ?? "");
    const onCancelar = onClose ?? (() => navigate(-1));    

    const {
        isPending,
        isSuccess,
        mutate,
        data
    } = useBuscarMutation({
        onSuccess(data, variables, context) {
        },
        onError(error, variables, context) {
            notification.info({
                ...PropriedadesDeNotificacao["Aviso"],
                message: "Não foi possível encontrar o titulo que deseja alterar.",
            });

            onCancelar?.();
        },
    });

    const tituloSalvo = isPending === false && isSuccess === true ? data : undefined;

    useEffect(() => {
        const isAlteracao = (codigo ?? 0) > 0;
        if (isAlteracao)
        {
            mutate({
                codigo : codigo ?? 0
            });
        }
    }, [codigo]);

    return (
        <TelaCarregamento ativo={isPending}>
            {
                tituloSalvo?.data?.devedor?.tipo === EnumPessoaTipo.EMPRESA 
                    && <APagarLancamentoForm 
                        popular={false}
                        disabled={true}
                        initialValues={{
                            titulo : tituloSalvo?.data
                        }}
                    /> 
                    || <AReceberLancamentoForm 
                        popular={false}
                        disabled={true}
                        initialValues={{
                            titulo : tituloSalvo?.data
                        }}
                    />
            }
            <Divider></Divider>
            <Flex justify="center">
                <Button type="primary" danger onClick={onCancelar}>Fechar</Button>
            </Flex>
        </TelaCarregamento>
    );
}